import { isTermsEmpty } from '@paintscout/util/builder'
import Section from './TermsBlock'

// `isTermsEmpty` is the block's own empty test, shared with the v1 section
// (`presentation/sections/Terms`) so the two cannot drift apart. It reads only `quote` and `options`
// off the props the registry hands it.
export default { isEmpty: isTermsEmpty, Section }
